export enum ETASource {
  COMPLETE_STOP = "completeStop",
  GPS_UPDATE = "gpsUpdate",
  OPTIMIZATION_SERVICE = "optimizationService",
  ROUTE_PLANNING = "routePlanning"
}
